<template lang="pug">
  div
    v-row(no-gutters)
      h2.pb-4 Fundings
      v-btn(
        color="primary"
        depressed
        v-if="!localBeneficiary.activeFunding"
        @click.stop="showAddFunding = true"
        :disabled="showAddFunding"
      ).plain.mx-4 
        v-icon(left) mdi-plus
        | New
    div(v-if="!showAddFunding && localFundings.length !== 0")
      v-row
        v-col(cols="12")
          v-card
            v-card-text.pt-0
              v-tabs(v-model="tab")
                v-tab(
                  v-for="(funding, i) in localFundings"
                  :key="i"
                ) {{ funding.name }}
                v-tabs-items(v-model="tab")
                  v-tab-item(
                    v-for="(funding, i) in localFundings"
                    :key="i"
                  )
                    v-row
                      v-col(cols="6") 
                        h3.my-4 Summary
                        p Funding's Purpose: {{ funding.name }}&nbsp&nbsp
                          v-chip(
                            small
                            outlined
                            :color="chipColor(funding)"
                          ) {{ chipText(funding) }}
                        p Description: {{ funding.description }}
                        h3 Total Amount: #[money(:value="funding.amount")]
                        h3 Amount Raised: #[money(:value="funding.raised")]
                      v-col(cols="6")
                        scholar-detail-breakdown-creator(
                          :beneficiary="beneficiary"
                          :funding="funding"
                          :isNew="false"
                        )
    div(v-if="showAddFunding")
      v-row.mx-0
        v-col(cols="7")
          v-form(
            ref="fund"
            v-model="validFund"
          )
            p.font-20.mb-0.pb-4 Summary
            v-text-field(
              label="Funding's Purpose"
              v-model="fundingName"
              clearable
              outlined
              :rules="[v => !!v || 'Purpose is required']"
              :disabled="fundLoading"
            )
            v-textarea(
              v-model="fundingDescription"
              label="Description"
              outlined
              auto-grow
              :disabled="fundLoading"
              :rules="[v => !!v || 'Description is required']"
            )
            v-row(no-gutters)
              p.mb-0.font-20 Total Amount: #[money(:value="fundingTotal")]
              v-spacer
              v-btn(
                depressed
                text
                color="error"
                :disabled="fundLoading"
                @click.stop="cancelAddNewFunding"
              ).plain.mr-4 Cancel
              v-btn(
                depressed
                color="primary"
                :disabled="fundingItems.length === 0 || !validFund"
                @click.stop="addFunding"
              ).plain Save
        v-col(cols="5")
          scholar-detail-breakdown-creator(
            :beneficiary="beneficiary"
            :isNew="true"
            @listChange="setList"
          )
</template>

<script>
import ScholarDetailBreakdownCreator from '@/components/scholar/ScholarDetailBreakdownCreator';
import Money from '@/components/commons/Money';

export default {
  props: {
    beneficiary: {
      type: Object
    },
    fundings: {
      type: Array
    }
  },
  components: {
    ScholarDetailBreakdownCreator,
    Money
  },
  data () {
    return {
      validFund: false,
      validBreakdown: false,
      validUpdateBreakdown: false,
      showAddFunding: false,
      showAddBreakdown: false,
      showUpdateAddBreakdown: false,
      fundLoading: false,
      localFundings: [],
      fundingName: '',
      fundingDescription: '',
      fundingTotal: 0,
      fundingItems: [],
      fundingItemName: '',
      fundingItemAmount: 5,
      tab: 0,
      localBeneficiary: {}
    };
  },
  watch: {
    fundings () {
      this.localFundings = this.fundings;
    },
    beneficiary () {
      this.localBeneficiary = this.beneficiary;
    }
  },
  methods: {
    async addFunding () {
      try {
        this.fundLoading = true;
        this.$setLoading(true);
        await this.$store.dispatch(
          'fundings/create',
          {
            beneficiary: this.localBeneficiary.id,
            name: this.fundingName,
            description: this.fundingDescription,
            items: this.fundingItems
          }
        );

        this.localBeneficiary = await this.$store.dispatch(
          'beneficiaries/getById',
          {
            id: this.localBeneficiary.id
          }
        );

        this.localFundings = await this.$store.dispatch(
          'fundings/get',
          {
            beneficiary: this.localBeneficiary.id
          }
        );

        this.showAddFunding = false;
        this.$enqueueSnack('Funding added');
      } catch (err) {
        this.$enqueueSnack(err);
      } finally {
        this.fundLoading = false;
        this.fundingName = '';
        this.fundingDescription = '';
        this.$refs.fund.resetValidation();
        this.$setLoading(false);
      }
    },
    async deleteFunding (index) {
      try {
        this.fundLoading = true;
        await this.$store.dispatch('beneficiaries/deleteFunding', {
          fundingId: this.localBeneficiary.activeFundingObject.items[index].id
        });
        this.localFundings = await this.$store.dispatch(
          'fundings/get',
          {
            beneficiary: this.localBeneficiary.id
          }
        );
      } catch (err) {
        console.log(err);
      }
      this.fundLoading = false;
    },
    setList (payload) {
      this.fundingTotal = payload.fundingTotal;
      this.fundingItems = payload.fundingItems;
    },
    cancelAddNewFunding () {
      this.fundLoading = false;
      this.fundingName = '';
      this.fundingDescription = '';
      this.showAddFunding = false;
      this.fundingItems = [];
      this.fundingTotal = 0;
      this.cancelAddBreakdownList();
      this.$refs.fund.resetValidation();
    },
    chipText (funding) {
      return funding.resolvedAt ? 'done' : this.localBeneficiary.activeFunding === funding.id && this.localBeneficiary.published ? 'ongoing' : 'unpublished';
    },
    chipColor (funding) {
      return funding.resolvedAt ? 'primary' : this.localBeneficiary.activeFunding === funding.id && this.localBeneficiary.published ? 'warning' : 'error';
    }
  }
};
</script>